import { connect } from 'react-redux';
import { SPQL } from './components';
import {
  getRecentlyRanSPQLQueries,
  getSavedSPQLQueries,
  getQueryExamples,
  createSPQLQuery,
  updateSPQLQuery,
  deleteSPQLQuery,
  getDeepScanMetadata,
  getDeepScan,
  changeSPQLQuery,
  changeSPQLSorting,
  changeSPQLSelectedColumns,
} from '../../redux/actions/deep_scan';

const mapStateToProps = (state) => {
  return {
    sortableFields: state.deepScan.sortableFields,
    filterableFields: state.deepScan.filterableFields,
    fieldsMetadata: state.deepScan.fieldsMetadata,
    defaultDisplayFields: state.deepScan.defaultDisplayFields,
    resultsMetadata: state.deepScan.results?.metadata ?? {},
    resultsData: state.deepScan.results?.data ?? [],
    resultsStatus: state.deepScan.resultsStatus,
    subscriptionPlanStatus: state.user.mySubscriptionPlanStatus,
    subscriptionPlan: state.user.mySubscriptionPlan,
  };
};

const mapDispatchToProps = {
  getDeepScanMetadata,
  getDeepScan,
  changeSPQLQuery,
  changeSPQLSorting,
  changeSPQLSelectedColumns,
  getRecentlyRanSPQLQueries,
  getQueryExamples,
  getSavedSPQLQueries,
  createSPQLQuery,
  updateSPQLQuery,
  deleteSPQLQuery,
};

export default connect(mapStateToProps, mapDispatchToProps)(SPQL);
